import React from "react";
import styles from "./PdfModal.module.scss";

const PdfModal = ({ closePdfModal, selectedProduct }) => {
  if (!selectedProduct) return null;
  const PDF = require.context("../../../../../public/product-pdf", true, /\.pdf$/);
  const { PdfPath } = selectedProduct;
  const getPdf = () => {
    return PDF.keys()
      .filter((file) => file.startsWith(`./${PdfPath}`))
      .map((filePath) => `${process.env.PUBLIC_URL}/product-pdf${filePath.substring(1)}`);
  };

  const pdf = getPdf();

  return (
    <div className={styles.modal}>
      <div className={styles.modalContent}>
        <span className={styles.close} onClick={closePdfModal}>
          <p>Close</p>
        </span>
        <iframe className={styles.iframe} src={`${pdf[0]}#view=fitH`} maxwidth="500px" frameBorder="0" title="Product PDF"></iframe>
      </div>
    </div>
  );
};

export { PdfModal };
